import type { FC } from "react";

import { LoyaltyVideoPreview as UILoyaltyVideoPreview } from "@jti/loyalty";

import { buildLoyaltyVideoUIProps } from "@/components/LoyaltyVideoPlayer/buildLoyaltyVideoUIProps";
import type { loyaltyVideoPreviewInputs } from "@/components/LoyaltyVideoPreview/LoyaltyVideoPreview.builder";

export type LoyaltyVideoPreviewProps = BuilderComponentProps<typeof loyaltyVideoPreviewInputs> & {
  fullHeight?: boolean;
};

export const LoyaltyVideoPreview: FC<LoyaltyVideoPreviewProps> = ({ fullHeight, ...props }) => {
  const videoProps = buildLoyaltyVideoUIProps(props);

  if (!videoProps) {
    return null;
  }

  return <UILoyaltyVideoPreview {...videoProps} fullHeight={fullHeight} />;
};
